import React from "react";
import mainLogoSvg from "../../assets/img/Main logo.png";

function LogoSection() {
  return (
    <div className="flex items-center justify-center gap-[2rem] py-[.5rem] bg-white">
      <img  className='object-contain' src={mainLogoSvg} alt="mainLogoSvg" />
      <span className="lg:text-[1.4375rem] text-[.75rem] text-[#1A1A1A] font-sora font-[700]">
        NATIONAL IRRIGATION SECTOR INVESTMENT PLAN
      </span>
    </div>
  );
}

export default LogoSection;
